import { render, staticRenderFns } from "./PersistCategoryView.vue?vue&type=template&id=62c57899"
import script from "./PersistCategoryView.vue?vue&type=script&lang=ts"
export * from "./PersistCategoryView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports